export default __webpack_public_path__ + "static/media/V230_D_BD.b4d0f6fa.pdf";